export default function focusField({ state, input }) {
  if (input.path) {
    state.set('client.registrating.hasFocus', input.path)
    state.merge(input.path, { hasFocus: input.focus })
  }
}



// WEBPACK FOOTER //
// ./src/modules/client/actions/focusField.js